<template>
  <div class="ai-collapse">
    <button class="collapse-head" type="button" :title="block.tool || ''" @click="open = !open">
      <span class="chevron" :class="{ rotated: open }">▸</span>
      <span v-if="isThinking" class="collapse-title thinking">Мышление модели</span>
      <span v-else class="collapse-title tool">{{ toolLabel }}</span>
      <span v-if="running" class="collapse-hint running">выполняется…</span>
      <span v-else-if="hint" class="collapse-hint">{{ hint }}</span>
    </button>
    <div v-if="open" class="collapse-body">
      <div v-if="isThinking" class="thinking-text">{{ block.text }}</div>
      <template v-else>
        <div v-if="block.tool" class="tool-raw">инструмент: {{ block.tool }}</div>
        <div v-if="argsPretty" class="json-block">
          <div class="json-label">Аргументы</div>
          <pre>{{ argsPretty }}</pre>
        </div>
        <div v-if="summaryPretty" class="json-block">
          <div class="json-label">Результат</div>
          <pre>{{ summaryPretty }}</pre>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { TOOL_LABELS } from '../toolLabels';

function pretty(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch (e) {
    return String(value);
  }
}

export default {
  name: 'AiCollapsibleBlock',
  props: {
    block: { type: Object, required: true },
  },
  data() {
    return { open: false };
  },
  computed: {
    isThinking() {
      return this.block.type === 'thinking';
    },
    running() {
      return !!this.block.running;
    },
    toolLabel() {
      return TOOL_LABELS[this.block.tool] || this.block.tool || 'Инструмент';
    },
    hint() {
      if (this.isThinking) return '';
      const summary = this.block.summary;
      if (summary && summary.error) return 'ошибка: ' + summary.error;
      if (!summary || typeof summary !== 'object') return 'готово';
      const parts = [];
      if (summary.dataset) parts.push(summary.dataset);
      if (summary.row_count !== undefined) parts.push(`строк: ${summary.row_count}`);
      if (summary.returned !== undefined) parts.push(`в выдаче: ${summary.returned}`);
      return parts.join(' · ') || 'готово';
    },
    argsPretty() {
      const args = this.block.args;
      if (!args || typeof args !== 'object' || !Object.keys(args).length) return '';
      return pretty(args);
    },
    summaryPretty() {
      const summary = this.block.summary;
      if (!summary || typeof summary !== 'object') return '';
      return pretty(summary);
    },
  },
};
</script>

<style scoped>
.ai-collapse {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.collapse-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  padding: 5px 10px;
  border: none;
  background: #f9fafb;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  font-family: inherit;
}

.collapse-head:hover {
  background: #f3f4f6;
}

.chevron {
  color: #9ca3af;
  font-size: 10px;
  transition: transform 0.15s ease;
  align-self: center;
}

.chevron.rotated {
  transform: rotate(90deg);
}

.collapse-title {
  font-weight: 600;
  color: #374151;
}

.collapse-title.thinking {
  color: #6b7280;
  font-style: italic;
  font-weight: 500;
}

.collapse-hint {
  color: #6b7280;
  font-size: 11px;
}

.collapse-hint.running {
  color: #9ca3af;
}

.collapse-body {
  padding: 8px 12px;
  border-top: 1px solid #f3f4f6;
}

.thinking-text {
  white-space: pre-wrap;
  word-break: break-word;
  color: #6b7280;
  font-style: italic;
  font-size: 12.5px;
  line-height: 1.5;
}

.tool-raw {
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 6px;
}

.json-block {
  margin-bottom: 6px;
}

.json-block:last-child {
  margin-bottom: 0;
}

.json-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 2px;
}

pre {
  margin: 0;
  padding: 8px;
  background: #f9fafb;
  border-radius: 4px;
  font-size: 11.5px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  color: #374151;
}
</style>
